 const passwordInput = document.getElementById("CustomerPassword");
    const togglePassword = document.getElementById("togglePassword");

    togglePassword.addEventListener("click", () => {
        const type = passwordInput.type === "password" ? "text" : "password";
        passwordInput.type = type;
});

//  const passwordInput = document.getElement("CustomerPassword");
//     const togglePassword = document.getElementById("togglePassword");

//     togglePassword.addEventListener("click", () => {
//         const type = passwordInput.type === "password" ? "text" : "password";
//         passwordInput.type = type;
// });

const passwordInput1 = document.getElementById("RegisterForm-password");
const togglePassword1 = document.getElementById("togglePassword");

togglePassword1.addEventListener("click", () => {
    const type1 = passwordInput1.type === "password" ? "text" : "password";
    passwordInput1.type = type;
});

